import { Box, Typography } from '@mui/material';
import StandardModal from '@/components/common/standard.modal';
import ReactMarkdown from 'react-markdown';
import type { TermDto } from '@/types/dtos/events/term.dto';
import { useTranslations } from '@/i18n/use-translations';

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
  term: TermDto | null;
}

export const TermsModal = ({ open, onClose, term }: TermsModalProps) => {
  const t = useTranslations();

  return (
    <StandardModal
      open={open}
      close={onClose}
      title={t('myEventsList.contributionsList.termsModalTitle')}
      menu={false}
      size="lg"
      height="600px"
      maxHeight="calc(100vh - 64px)"
      width="800px"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          gap: 2,
          position: 'relative',
        }}
      >
        {term ? (
          <Box
            sx={{
              'flex': 1,
              'overflow': 'auto',
              'p': 2,
              'border': '1px solid',
              'borderColor': 'divider',
              'borderRadius': 1,
              'backgroundColor': 'background.default',
              '& > *': {
                'marginTop': 0,
                'marginBottom': '1em',
                '&:last-child': {
                  marginBottom: 0,
                },
              },
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                marginTop: '1em',
                marginBottom: '0.5em',
                fontWeight: 600,
              },
              '& ul, & ol': {
                paddingLeft: '1.5em',
                marginBottom: '1em',
              },
              '& li': {
                marginBottom: '0.5em',
              },
              '& p': {
                marginBottom: '1em',
              },
              '& strong': {
                fontWeight: 600,
              },
              '& em': {
                fontStyle: 'italic',
              },
            }}
          >
            <ReactMarkdown>{term.text}</ReactMarkdown>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <Typography variant="body1" color="text.secondary">
              {t('myEventsList.contributionsList.noTermsAvailable')}
            </Typography>
          </Box>
        )}
      </Box>
    </StandardModal>
  );
};
